import { render } from "./AuthenticatorSetupOverlay.vue?vue&type=template&id=0e00cbae&scoped=true"
import script from "./AuthenticatorSetupOverlay.vue?vue&type=script&lang=js"
export * from "./AuthenticatorSetupOverlay.vue?vue&type=script&lang=js"

import "./AuthenticatorSetupOverlay.vue?vue&type=style&index=0&id=0e00cbae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e00cbae"]])

export default __exports__